class StickyQuicklinks extends HTMLElement {
  constructor () {
    super()
    this.list = null
    this.observer = null
    this.lastScrollTop = 0
    this.ticking = false

    // Try and smooth out the switch by making sure the intersection accounts for the header height
    let rootMargin = 0
    const headerGroup = document.querySelector('[js-header]')

    if (headerGroup) {
      rootMargin = headerGroup.offsetHeight
    }

    // Avoid Jank when the container element is back in view and the links become static
    const container = document.querySelector('.collection-hero')

    if (container) {
      console.log(container.style.setProperty('min-height', container.offsetHeight + 'px'))
    }

    this.options = {
      root: null,
      threshold: 0,
      rootMargin: `-${rootMargin}px 0px 0px 0px`
    }

    this.scrollDir = this.scrollDir.bind(this)
    this.handleIntersect = this.handleIntersect.bind(this)
  }

  connectedCallback () {
    this.list = this.querySelector('[data-sticky-quicklinks-el="list"]')

    this.observer = new IntersectionObserver(this.handleIntersect, this.options)
    this.observer.observe(this)

    this.setupListeners()
  }

  setupListeners () {
    window.addEventListener('scroll', this.scrollDir)
  }

  scrollDir () {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop

        if (scrollTop > this.lastScrollTop) {
          document.documentElement.setAttribute('data-scroll-dir', 'down')
        } else if (scrollTop < this.lastScrollTop) {
          document.documentElement.setAttribute('data-scroll-dir', 'up')
        }

        this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop
        this.ticking = false
      })

      this.ticking = true
    }
  }

  handleIntersect (entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        console.log(`Visible ratio: ${entry.intersectionRatio}`)
        // Fire when at least 90% visible
        if (entry.intersectionRatio >= 0.9) {
          console.log('Element is at least 90% visible!')
        }
        this.list.classList.remove('fixed')
        document.documentElement.classList.remove('plp-fixed')
      } else {
        this.list.classList.add('fixed')
        document.documentElement.classList.add('plp-fixed')
        document.documentElement.style.setProperty('--links-offset', `${this.list.offsetHeight}px`)
      }
    })
  }
}

if (!window.customElements.get('sticky-quicklinks')) {
  window.customElements.define('sticky-quicklinks', StickyQuicklinks)
}
